import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { SLIMCUT_CONTAINER_ID } from '../../constants';
import { loadAdSlots } from '../../utils/ads/webAdLib';
import { onHomepage } from '../../utils/dom';

const onMountOrUpdate = function() {
  /*
   * We can't arrow-bind this because we need the "this" context to be lexically
   * bound to the component on instantiation.
   */
  if (!this.props.adTargetingCompleted) {
    return;
  }

  loadAdSlots();
};

export default class SlimcutAdTag extends Component {
  /*
   * A 1x1 hardcoded GPT ad tag that's used for Slimcut. Since it doesn't rely
   * on our ad_data from the API response, we're not using the default Ad component.
   */

  componentDidMount = onMountOrUpdate;

  shouldComponentUpdate = nextProps =>
    nextProps.adTargetingCompleted !== this.props.adTargetingCompleted;

  componentDidUpdate = onMountOrUpdate;

  getSlotId = () => {
    const { adTargetingCompleted, adPageType } = this.props;
    const { location, edition_data } = this.context;
    const pageType = onHomepage(location, edition_data) ? 'homepage' : adPageType;
    return adTargetingCompleted ? `${pageType}-invusion` : '';
  };

  getTargeting = () => JSON.stringify({
    'ad_count': 1
  });

  render = () => (
    <div className="oop-ad-unit-container">
      <div
        id={SLIMCUT_CONTAINER_ID}
        data-slot-id={this.getSlotId()}
        data-ad-position="invusion"
        data-targeting={this.getTargeting()}
      />
    </div>
  );
}

SlimcutAdTag.propTypes = {
  adTargetingCompleted: PropTypes.bool.isRequired,
  adPageType: PropTypes.string.isRequired
};

SlimcutAdTag.contextTypes = {
  edition_data: PropTypes.object,
  location: PropTypes.object
};
